
(function () {
    'use strict';

    // @ngInject
    Services.FacebookPixel = function facebook($window, $interval, $q) {

        var self = this;
        var defer = $q.defer();
        var promise = defer.promise;
        if(!$window.fbq){
            var intervalHandle = $interval(function tryGetFBQ(){
                if($window.fbq){
                    defer.resolve($window.fbq);
                    $interval.cancel(intervalHandle);
                }
            }, 200);
        }else{
            defer.resolve($window.fbq);
        }
        return promise;
    };
}());
